import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgLj(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M21.7822 18.796C20.2142 19.4846 18.9553 20.7508 18.276 22.3209L22.7041 23.2366L21.7853 18.796H21.7822ZM3.02222 9.62233C4.18888 6.91255 6.35733 4.73789 9.06088 3.55566L11.6275 6.10989C13.0462 5.497 14.6101 5.15478 16.2558 5.15478C22.6917 5.15478 27.9111 10.368 27.9111 16.7997C27.9111 23.2314 22.6917 28.4446 16.2558 28.4446C9.81585 28.4446 4.59851 23.2345 4.59851 16.7997C4.59851 15.1497 4.96666 13.6046 5.58577 12.1838L15.0674 21.6354C16.2341 18.9256 18.4046 16.7509 21.1061 15.5687L11.6327 6.11092C8.92192 7.29315 6.75555 9.47092 5.58577 12.1776L3.02222 9.62233Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgLj);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
